import { Dialog } from "@mui/material";
import useAddEditSalaryTemplate from "../../hooks/salaryTemplates/useAddEditSalaryTemplate";
import { Button, Input } from "../ui";

const AddSalaryTemplateModal = ({ isOpen, toggleModal }) => {
  const { control, handleSubmit, addTemplate, onFormError, isAdding } =
    useAddEditSalaryTemplate({
      onTemplateAdded: () => {
        toggleModal();
      },
    });

  return (
    <Dialog open={isOpen} onClose={toggleModal} maxWidth="sm" fullWidth>
      <div className="p-4">
        <h2 className="font-semibold text-xl">Add Salary Template</h2>

        <form
          onSubmit={handleSubmit(addTemplate, onFormError)}
          className="flex flex-col mt-5"
        >
          <Input
            name="name"
            control={control}
            label="Template Name"
            placeholder="Enter template name"
          />
          <div className="my-3"></div>
          <Input
            name="annual_ctc"
            control={control}
            label="Annual CTC"
            placeholder="Enter CTC amount"
            isPositiveNumber
            type="number"
          />

          <Button type="submit" className={"mx-auto mt-5"} disabled={isAdding}>
            Add Template
          </Button>

          {isAdding && (
            <p className="mt-4 text-center w-full">Adding template...</p>
          )}
        </form>
      </div>
    </Dialog>
  );
};

export default AddSalaryTemplateModal;
